/**
 * textarea の内容量に応じた高さ調整（field-sizing: content に近い挙動）
 */
export default class Form {
	constructor(selector = 'textarea.l-form__textarea') {
		this.selector = selector;
		this.textareas = [];
		this.zipSelector = 'input.form-input-zip';
		this.zipInputs = [];
		this.onInput = this.onInput.bind(this);
		this.onZipInput = this.onZipInput.bind(this);
		this.onWindowResize = this.onWindowResize.bind(this);
	}

	init() {
		this.textareas = Array.from(document.querySelectorAll(this.selector));
		this.zipInputs = Array.from(document.querySelectorAll(this.zipSelector));
		if (this.textareas.length === 0 && this.zipInputs.length === 0) {
			return;
		}

		this.textareas.forEach((textarea) => {
			textarea.style.overflowY = 'hidden';
			this.adjustHeight(textarea);
			textarea.addEventListener('input', this.onInput);
		});

		this.zipInputs.forEach((input) => {
			input.addEventListener('input', this.onZipInput);
		});

		window.addEventListener('resize', this.onWindowResize);
	}

	onInput(event) {
		this.adjustHeight(event.currentTarget);
	}

	onWindowResize() {
		this.textareas.forEach((textarea) => {
			this.adjustHeight(textarea);
		});
	}

	onZipInput(event) {
		const input = event.currentTarget;
		const zip = input.value.replace(/\D/g, '');

		if (zip.length !== 7) {
			input.dataset.postalLookupZip = '';
			return;
		}

		if (input.dataset.postalLookupZip === zip) {
			return;
		}

		if (typeof window.okinawaUccPostalLookup !== 'function') {
			return;
		}

		input.dataset.postalLookupZip = zip;
		window.okinawaUccPostalLookup(input);
	}

	adjustHeight(textarea) {
		textarea.style.height = 'auto';
		// scrollHeight と border / サブピクセル描画の差で数 px 足りずスクロールバーが出るのを防ぐ
		const h = textarea.scrollHeight;
		textarea.style.height = `${Math.ceil(h) + 2}px`;
	}
}
